/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-01-29 14:34:03
 */
export class Infomation {
  id: string
  title: string
  content: string
  poster: string
  createDate: string
  likes: number
  linkUrl: string
  total?: string
  constructor (id: string, title: string, content: string, poster: string, createDate: string, likes = 0, linkUrl: string, total?: string) {
    this.id = id
    this.title = title
    this.content = content
    this.poster = poster
    this.createDate = createDate
    this.likes = likes
    this.linkUrl = linkUrl
    this.total = total
  }
}
export class Banner {
  url: string
  imgUrl: string
  publish: boolean
  sort: number
  constructor (url: string, imgUrl: string, publish: boolean, sort: number) {
    this.url = url
    this.imgUrl = imgUrl
    this.publish = publish
    this.sort = sort
  }
}
